import React, { Component } from 'react';
import { Map, List, fromJS } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'semantic-ui-react';

import fileDownload from 'js-file-download';

import { AdminLog, AdminPageTitle, AdminPageTemplate, Loading } from 'components';

import * as common from 'libs/commonFunc';
import * as admLib from 'libs/adminLib';
import * as logActions from 'modules/log';
let SEARCH_VALUE = '';
//let logDetailContents = {};

class CtAdminLog extends Component {
  constructor(props) {
    super(props);
    // 검색 기록 유지
    const { paramData } = this.props;
    const filterData = paramData.get('filter').toJS();
    let searchTypeData = 'searchAll';
    let searchTextData = '';
    if (Object.keys(filterData).length) {
      const searchOptions = [
        'searchAll',
        'serviceNo',
        'serviceName',
        'logNo',
        'logCategory',
        'userName',
        'userEmail',
        'regIp',
        'logTitle'
      ];
      searchOptions.map(option => {
        if (filterData[option]) {
          searchTypeData = option;
          searchTextData = filterData[option];
        }
      });
    }

    this.state = {
      loading: false,
      logLoadig: false,
      downloadLoading: false,
      data: [],
      pages: null,
      fromNowView: false,
      filter: '',
      sort: '',
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: searchTypeData,
      searchText: searchTextData,
      saveScrollTop: 0,
      logDetailContent: {},
      tempFilter: {},
      expanded: {}
    };

    this.onRefRegister = this.onRefRegister.bind(this);
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, paramData, expanded } = this.props;

    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData
    ) {
      this.getAdminLog();
      this.setState({ expanded: expanded });
    }

    if (!!this.moveList) {
      this.onMoveScroll();
    }
  }

  onMoveScroll = () => {
    // this.moveList.scrollTo(0, this.state.saveScrollTop);
    this.moveList.scrollTop = this.state.saveScrollTop;
  };

  // 스크롤 ref 등록
  onRefRegister = (id, refObject) => {
    if (!!refObject) {
      this[id] = refObject;
    }
  };

  getAdminLog = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    try {
      const { currentPage, pageSize } = this.state;
      const { LogActions, paramData } = this.props;
      const params = {
        filter: JSON.stringify(paramData.get('filter')),
        sort: JSON.stringify(paramData.get('sort')),
        offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
        limit: pageSize < 1 ? 20 : pageSize
      };

      await LogActions.getSystemLog(params);
    } catch (e) {
      console.log(e);
    }

    this.setState({ loading: false });
  };

  // 로그 상세 정보 조회
  logDetail = async logNo => {
    if (!this.state.logLoading) {
      this.setState({ logLoading: true });
    }

    try {
      const { logDetailContent, logDetailList } = this.state;
      const respObj = await admLib.getSystemLogdetail({ logNo: logNo });
      if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
        const logDetail = respObj.data.list.logDetail;
        let logs = {};

        if (Object.keys(logDetailContent).length > 0) {
          logs = logDetailContent;
        }

        // 스크롤 있는 상태에서 눌렀을 경우 스크롤 위치 저장
        logs[logNo] = logDetail;
        if (this.moveList && this.moveList.scrollTop !== this.state.saveScrollTop) {
          const scrollTop = this.moveList.scrollTop;
          this.setState({ logDetailContent: logs, saveScrollTop: scrollTop });
        } else {
          logs[logNo] = logDetail;
          this.setState({ logDetailContent: logs });
        }
      } else {
        this.setState({ logDetailContent: {} });
      }
    } catch (e) {
      console.log(e);
    }
    this.setState({ logLoading: false });
  };

  // 상세 보기 내용
  logDetailComponent = row => {
    const { onRefRegister } = this;
    const { formatMessage } = this.props.intl;
    //const logDetailContent = logDetailContents[row.row.logNo];
    const logDetailContent = this.state.logDetailContent[row.row.logNo];
    let logDetail = '';
    let logDetailReq = '';
    let logDetailRes = '';

    if (typeof logDetailContent !== 'undefined') {
      const jsonLogDetail = JSON.parse(logDetailContent);

      if (logDetailContent.indexOf('req') > -1 || logDetailContent.indexOf('res') > -1) {
        logDetailReq = jsonLogDetail.req;
        logDetailRes = jsonLogDetail.res;
      } else {
        // 변경 전 로그
        logDetail = jsonLogDetail;
      }
    }

    return (
      <div className={'react-table-td-sub-area systemLog-content'}>
        {this.state.logLoading && (
          <div className={'systemLog-res'}>
            <Loading content={'Loading...'} />
          </div>
        )}
        {Object.keys(logDetailReq).length > 0 && (
          <div className={'systemLog-res'}>
            <div className={'systemLog-title'}>request</div>
            <pre>{JSON.stringify(logDetailReq, null, 4)}</pre>
          </div>
        )}
        {Object.keys(logDetailRes).length > 0 && (
          <div className={'systemLog-res'}>
            <div className={'systemLog-title'}>response</div>
            <pre>{JSON.stringify(logDetailRes, null, 4)}</pre>
          </div>
        )}
        {Object.keys(logDetail).length > 0 && (
          <div className={'systemLog-res'}>
            <pre>{JSON.stringify(logDetail, null, 4)}</pre>
          </div>
        )}
        {Object.keys(logDetailReq).length === 0 &&
          Object.keys(logDetailRes).length === 0 &&
          Object.keys(logDetail).length === 0 && <div className={'systemLog-res'}>
            {!!this.state.logLoading ? '' : defineMessages(formatMessage({ id: 'CtAdminLog_4', defaultMessage: '로그가 존재하지 않습니다.' }))}
          </div>}
      </div>
    );
  };

  //구분 필터
  logTypeFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['logType'] === 'undefined') {
      filter['logType'] = Number(data.value);
    } else {
      if (Number(data.value) & tempFilter['logType']) {
        filter['logType'] -= Number(data.value);

        // 필터 array가 없다면 삭제
        if (filter['logType'].length === 0) {
          delete filter['logType'];
        }
      } else {
        filter['logType'] += Number(data.value);
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { LogActions } = this.props;
    LogActions.changeParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색어 입력
  handleChangeSearch = e => {
    this.setState({ searchText: e.target.value });
  };

  // 검색
  handleOnSearch = e => {
    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const searchType = this.state.searchType;
      const searchValue = SEARCH_VALUE;

      const { LogActions, paramData } = this.props;
      const filter = paramData.get('filter').toJS();

      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = [
          'searchAll',
          'serviceNo',
          'serviceName',
          'logNo',
          'logCategory',
          'userName',
          'userEmail',
          'regIp',
          'logTitle'
        ];
        searchOptions.map(option => delete filter[option]);

        if (searchValue !== '') {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        LogActions.changeParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 체크 취소
  cancleCheck = () => {
    const { LogActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter
    });
  };

  // // 개별 필터
  // handleChangeFilter = (column, value, isMulti) => {
  //   const { LogActions, paramData } = this.props;
  //   const filter = paramData.get('filter').toJS();

  //   // 멀티 선택 필터
  //   if (isMulti) {
  //     if (typeof filter[column] === 'undefined') {
  //       filter[column] = value;
  //     } else if (Number(filter[column]) === Number(value)) {
  //       delete filter[column];
  //     } else {
  //       if (Number(value) & Number(filter[column])) {
  //         filter[column] = Number(filter[column]) - Number(value);
  //       } else {
  //         filter[column] = Number(filter[column]) + Number(value);
  //       }
  //     }
  //     // 단일 선택 필터
  //   } else {
  //     if (filter[column] === value) {
  //       delete filter[column];
  //     } else {
  //       filter[column] = value;
  //     }
  //   }

  //   this.setState({ currentPage: 0 });
  //   LogActions.changeParam({
  //     name: 'filter',
  //     value: fromJS(filter)
  //   });
  // };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { LogActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    // if (data.selectedRecentDate) {
    //   filter['selectedRecentDate'] = data.selectedRecentDate;
    // }
    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    LogActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    const { LogActions } = this.props;

    LogActions.changeParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };

  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo, expanded: {} });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { LogActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    LogActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  //시스템 로그 다운로드
  systemLogDownload = async () => {
    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { paramData } = this.props;
      const { currentPage, pageSize } = this.state;

      if (!this.state.downloadLoading) {
        this.setState({ downloadLoading: true });

        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort'))
          // offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          // limit: pageSize < 1 ? 20 : pageSize
        };

        const respObj = await admLib.systemLogDownload(params);
        if (respObj && respObj.status && respObj.status === 200) {
          if (respObj.data) {
            fileDownload(
              respObj.data,
              defineMessages(formatMessage({ id: 'CtAdminLog_2', defaultMessage: 'MudFix 로그' })) +
              '(' +
              common.timeFormatFromUTCEpoch(common.nowEpoch()) +
              ').xlsx'
            );
          } else {
            // 응답 데이터 오류
          }
        } else {
          // 응답 오류
        }
      }

      this.setState({ downloadLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      loading,
      downloadLoading,
      fromNowView,
      currentPage,
      pageSize,
      fitRowCount,
      searchType,
      searchText,
      expanded,
      saveScrollTop,
      logDetailContent,
      tempFilter
    } = this.state;
    const { logData, totalPages, totalCount, paramData } = this.props;
    const { logDetail, logDetailComponent } = this;
    const { handleFetchData, takeSearchValue } = this;
    const { onRefRegister, onMoveScroll } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      logTypeFilter,
      handleChangeFilter,
      handleChangeDateFilter,
      handleInitFilter,
      searchTextRef,
      cancleCheck,
      filterClose,
      executeFilter
    } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    // 검색 필터
    const searchOptions = [
      { key: 0, text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })), value: 'searchAll' },
      {
        key: 1,
        text: defineMessages(formatMessage({ id: 'AdminLog_4', defaultMessage: '서비스No' })),
        value: 'serviceNo'
      },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'AdminLog_19', defaultMessage: '서비스명' })),
        value: 'serviceName'
      },
      { key: 3, text: 'No', value: 'logNo' },
      { key: 4, text: 'API', value: 'logCategory' },
      { key: 5, text: defineMessages(formatMessage({ id: 'AdminLog_2', defaultMessage: '이름' })), value: 'userName' },
      {
        key: 6,
        text: defineMessages(formatMessage({ id: 'AdminLog_3', defaultMessage: '이메일' })),
        value: 'userEmail'
      },
      { key: 7, text: defineMessages(formatMessage({ id: 'AdminLog_10', defaultMessage: '접속 IP' })), value: 'regIp' },
      { key: 8, text: defineMessages(formatMessage({ id: 'AdminLog_12', defaultMessage: '작업' })), value: 'logTitle' }
    ];

    return (
      <AdminPageTemplate className={fromNowView ? 'from-now-view table' : 'table'}>
        <AdminPageTitle
          type="table"
          title={defineMessages(formatMessage({ id: 'CtAdminLog_1', defaultMessage: '시스템 로그 조회' }))}>
          <Button
            className="bt-style-gleam common-button-brand"
            loading={downloadLoading}
            size="small"
            content={defineMessages(formatMessage({ id: 'CtAdminLog_3', defaultMessage: '로그 다운로드' }))}
            onClick={this.systemLogDownload}
            color="blue"
          />
        </AdminPageTitle>
        <AdminLog
          manual
          data={logData && Map.isMap(logData) ? logData.toJS().success : {}}
          totalCount={totalCount}
          page={currentPage}
          pages={totalPages}
          pageSize={pageSize}
          defaultPageSize={fitRowCount}
          pageSizeOptions={pageSizeOptions}
          loading={loading}
          onFetchData={handleFetchData}
          //logDetailContents={logDetailContents}
          onRefRegister={onRefRegister}
          onMoveScroll={onMoveScroll}
          saveScrollTop={saveScrollTop}
          expanded={expanded}
          logDetailContent={logDetailContent}
          logDetail={logDetail}
          logDetailComponent={logDetailComponent}
          // 검색 영역
          searchObj={{
            filterData: filterData,
            currentPage: currentPage,
            pageSize: pageSize,
            totalCount: totalCount,
            searchType: searchType,
            searchText: searchText,
            searchOptions: searchOptions,
            handleSearchOptions: handleSearchOptions,
            handleChangeSearch: handleChangeSearch,
            handleOnSearch: handleOnSearch,
            handleInitFilter: handleInitFilter,
            defaultPageSize: fitRowCount,
            pageSizeOptions: pageSizeOptions,
            handlePageSizeOnChange: handlePageSizeOnChange,
            takeSearchValue: takeSearchValue,
            searchTextRef: searchTextRef,
            paramData: paramData,
            tempFilter: tempFilter
          }}
          // 필터
          logTypeFilter={logTypeFilter}
          cancleCheck={cancleCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          handleChangeDateFilter={handleChangeDateFilter}
          // 페이징 처리
          handlePagination={handlePagination}
        />
      </AdminPageTemplate>
    );
  }
}

const mapStateToProps = state => {
  return {
    logData: state.log.get('data'),
    needReload: state.log.get('needReload'),
    totalPages: state.log.get('totalPages'),
    totalCount: state.log.get('totalCount'),
    paramData: state.log.get('param')
  };
};

const mapDispatchToProps = dispatch => ({
  LogActions: bindActionCreators(logActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminLog));



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminLog.js